import { render, staticRenderFns } from "./regNo.vue?vue&type=template&id=cdacfcca&scoped=true"
import script from "./regNo.vue?vue&type=script&lang=js"
export * from "./regNo.vue?vue&type=script&lang=js"
import style0 from "./regNo.vue?vue&type=style&index=0&id=cdacfcca&prod&scoped=true&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdacfcca",
  null
  
)

export default component.exports